import { enqueueActions } from 'xstate5';

import { getAddTimeoutId, removeSelectionId } from '../../helpers';
import { type BundleMachineAction, type SelectionParams } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Records a product that reported it is in the bag.
 */
export const settleAddedProduct: BundleMachineAction<SelectionParams> = enqueueActions(
  (args, params: SelectionParams) => {
    const { context, enqueue } = args;
    const { selectionId } = params;
    const { productAdds } = context;

    enqueue.cancel(getAddTimeoutId(selectionId));
    enqueue.assign({
      productAdds: {
        ...productAdds,
        inFlight: removeSelectionId({ selectionIds: productAdds.inFlight, selectionId }),
        added: [...productAdds.added, selectionId],
      },
    });
  },
);
